import Carousel from "@plugins/carousel/components/Carousel";
import CarouselItem from "@plugins/carousel/components/CarouselItem";

const Plugin = {
  install(app) {
    app.component("carousel", Carousel);
    app.component("carousel-item", CarouselItem);
  },
};

export default Plugin;
